import { useState } from 'react'
import { Navbar } from './components/Navbar'
import { Hero } from './components/Hero'
import { LanzaderaBanner } from './components/LanzaderaBanner'
import { ProblemSolution } from './components/ProblemSolution'
import { AgentDreamTeam } from './components/AgentDreamTeam'
import { VirtualOfficeSection } from './components/VirtualOfficeSection'
import { PricingAndRoi } from './components/PricingAndRoi'
import { DemoBookingForm } from './components/DemoBookingForm'
import { Footer } from './components/Footer'
import { LegalModal } from './components/LegalModal'
function App() {
  const [legalModalType, setLegalModalType] = useState(null)
  const scrollToSection = (sectionId) => {
    const el = document.getElementById(sectionId)
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' })
    }
  }
  const handleExploreOffice = () => {
    scrollToSection('oficina-virtual')
  }
  const handleBookDemo = () => {
    scrollToSection('demo-form')
  }
  return (
    <div className="min-h-screen bg-[#012622] text-[#CBD5E1] flex flex-col selection:bg-[#00FF9D]/25 selection:text-[#00FF9D]">
      {/* Top Navigation */}
      <Navbar onOpenDemoModal={handleBookDemo} />

      {/* Main Content Sections */}
      <main className="flex-grow">
        {/* 1. Hero Section */}
        <Hero
          onExploreOffice={handleExploreOffice}
          onBookDemo={handleBookDemo}
        />

        {/* 2. Lanzadera Authority Banner */}
        <LanzaderaBanner />

        {/* 3. El Problema vs La Solución Hutrit */}
        <ProblemSolution />

        {/* 4. El "Dream Team" de Agentes de IA */}
        <AgentDreamTeam />

        {/* 5. Tu Oficina Virtual 24/7 */}
        <VirtualOfficeSection />

        {/* 6. Precios y Calculadora de ROI */}
        <PricingAndRoi onSelectPlan={handleBookDemo} />

        {/* 7. Sección de Conversión (Formulario) */}
        <DemoBookingForm />
      </main>

      {/* 8. Footer */}
      <Footer onOpenLegal={(type) => setLegalModalType(type)} />

      {/* Legal & Information Modal */}
      <LegalModal
        type={legalModalType}
        onClose={() => setLegalModalType(null)}
      />
    </div>
  )
}
export { App as default }
